<template>
        <!-- Top Bar Start -->
  <div class="topbar">
      <!-- LOGO -->
      <div class="topbar-left">
        <li class="dropdown notification-list list-inline-item d-none d-md-inline-block">
            <h4 v-if="vendor_name != 'false' && vendow_name != 'null'" ><font color="white">{{vendor_name}}</font></h4>
            <h5 v-if="vendor_id != 'false' && vendor_id != 'null'">
                
                <font color="white">{{vendor_id}}</font>
                 
           </h5>
        </li>
        
      </div>
      <!-- <div class="dropdown-divider"></div> -->
      <nav class="navbar-custom">
          <button class="btn btn-secondary menuBtn" v-on:click.prevent ="showSideBar">
              <div class="amburger"></div>
              <div class="amburger"></div>
              <div class="amburger"></div>
          </button>
          <img class="main-logo" src="assets/images/aboutlogo.png" alt="logo" >
        
      </nav>
  </div>
        <!-- Top Bar End -->
</template>
<script>
import SideNav from './SideNav'
export default {
    data(){
        return{
            vendor_name:null,
            vendor_id:null
        }
    },
    mounted(){
        this.vendor_name = sessionStorage.getItem("vendor_name");
        this.vendor_id = sessionStorage.getItem("vendor_id");
    },
    methods: {
    logout(){
      sessionStorage.clear();
      //this.$router.push("login");
       window.location.assign("http://localhost:8080/login");
    },
    showSideBar() {
        SideNav.methods.toggleSideNav();
    }
    
  }
};
</script>
<style scoped>


.menuBtn {
            display: none;
    }
    .amburger {
        border: solid white 2px;
        margin: 5px 20px 5px -5px;
        min-width: 150%;
        border-radius: 3px;
    }
    @media only screen and (max-width: 750px) {
        .main-logo {
            margin-left: 5%;
        }
        .menuBtn {
            display: inline;
        }
    }
    

</style>
